import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    input: {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    boxWithDescription: {
      marginBottom: theme.spacing(10),
      cursor: 'pointer',
    },
    addAction: {
      textTransform: 'capitalize',
      cursor: 'pointer',
      color: '#1174F2',
      fontSize: 18,
    },
    editIcon: {
      padding: theme.spacing(1),
    },
    titleText: {
      ...CommonFonts.darkFont18,
    },
    checkbox: {
      color: '#55CC66',
      '&$checked': {
        color: '#55CC66',
      },
    },
    parentItem: {
      ...CommonFonts.darkFont18,
      color: 'black',
      fontWeight: '600',
      padding: theme.spacing(4),
      backgroundColor: '#d6dbdf',
    },
    childItem: {
      ...CommonFonts.darkFont18,
      color: 'black',
      padding: theme.spacing(4),
    },
  })
);

export default useStyles;
